import React, { useState } from "react";
import { useController } from "react-hook-form";

import { ReactComponent as RadioOn } from "assets/icons/radio-on.svg";
import { ReactComponent as RadioOff } from "assets/icons/radio-off.svg";
import { formatter } from "utils/helpers";

const RadioSelectorDrop = ({ name, control, defaultValue = "", levels }) => {
  const [expandedTier, setExpandedTier] = useState("luxury");

  const { field } = useController({
    name,
    control,
    defaultValue,
  });

  const handleSelectTier = (levelId) => {
    field.onChange(levelId);
    setExpandedTier(expandedTier === levelId ? null : levelId);
  };

  return (
    <div className="flex flex-col gap-4">
      {levels.map((level) => (
        <div
          key={level.id}
          className={`rounded-lg transition-all duration-200 bg-[#F2F4F7]  ${
            expandedTier === level.id ? "border-2 border-blue-100" : ""
          }`}
        >
          <div
            className="flex items-center justify-between p-2 cursor-pointer"
            onClick={() => handleSelectTier(level.id)}
          >
            <div className="flex items-center gap-2">
              <div
                className={`w-4 h-4 rounded-full flex items-center justify-center`}
              >
                {expandedTier === level.id ? <RadioOn /> : <RadioOff />}
              </div>
              <span className="text-sm font-medium text-gray-600">
                {level.title}
              </span>
              <span className="text-xs">{level?.icon}</span>

              {level?.price > 1 && (
                <span
                  className={`${
                    level?.title === "Budget"
                      ? "text-orange-400"
                      : level?.title === "Luxury"
                      ? "text-purple-500"
                      : "text-green-500"
                  } text-xs bg-white-100 p-1 rounded-full font-light `}
                >
                  {formatter.format(level?.price)}
                </span>
              )}
            </div>
            <div>
              <button type="button" className="text-gray-400">
                <svg
                  className={`${
                    expandedTier === level.id ? "rotate-0" : "rotate-180"
                  } h-4 w-4`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 15l7-7 7 7"
                  />
                </svg>
              </button>
            </div>
          </div>

          {level.description && expandedTier === level.id && (
            <div className="p-4 pt-0 text-gray-500 text-xs">
              {level.description}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RadioSelectorDrop;
